import { PlaybackPolicy } from '@shared/interfaces/assistantScript';
import { PolicyOption } from './interfaces';

export const POLICIES: PolicyOption[] = [
  {
    id: PlaybackPolicy.ALWAYS,
    icon: '🔄',
    name: 'Always',
    desc: 'Plays every time the user enters the area',
    color: '#7c3aed',
    bg: '#f5f3ff',
    darkColor: '#a78bfa',
    darkBg: 'rgba(167,139,250,0.12)',
  },
  {
    id: PlaybackPolicy.ONCE_SESSION,
    icon: '⭐',
    name: 'Once per session',
    desc: 'First entry per session — repeats on new sessions',
    badge: 'DEFAULT',
    color: '#2563eb',
    bg: '#eff6ff',
    darkColor: '#60a5fa',
    darkBg: 'rgba(96,165,250,0.12)',
  },
  {
    id: PlaybackPolicy.ONCE_USER,
    icon: '👤',
    name: 'Once per experience',
    desc: 'Plays only the very first time the user ever enters',
    color: '#059669',
    bg: '#ecfdf5',
    darkColor: '#34d399',
    darkBg: 'rgba(52,211,153,0.12)',
  },
  {
    id: PlaybackPolicy.FIRST_TIME,
    icon: '🆕',
    name: 'First-time users only',
    desc: "Only during the user's very first session across any experience",
    color: '#d97706',
    bg: '#fffbeb',
    darkColor: '#fbbf24',
    darkBg: 'rgba(251,191,36,0.12)',
  },
];
